import { render, staticRenderFns } from "./AnatomiasFisiologias.vue?vue&type=template&id=7bdb9f8e"
import script from "./AnatomiasFisiologias.vue?vue&type=script&lang=js"
export * from "./AnatomiasFisiologias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports